import { scrollToSection } from "@/App";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-royal border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p data-testid="footer-logo">
              <span className="inline-block bg-white px-4 py-2.5">
                <img src="/assets/dv-logo.png" alt="D V Steels — Strong. Reliable. Built to Last." className="h-8 md:h-9 w-auto" />
              </span>
            </p>
            <p className="mt-4 font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase text-white/60">
              Built for today. Ready for tomorrow.
            </p>
            <p className="mt-4 max-w-sm font-body text-sm text-white/70 leading-relaxed">
              Cable tray manufacturing unit in Ranipur, Pathankot — perforated trays,
              ladder trays and accessories, made in-house and dispatched across North India.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 mb-4">Quick Links</p>
            <ul className="flex flex-col gap-2.5 font-body text-sm text-white/80">
              {[["Why Us", "#why", "footer-link-why"], ["Products", "#products", "footer-link-products"], ["Capabilities", "#capabilities", "footer-link-capabilities"], ["Get a Quote", "#contact", "footer-link-contact"]].map(([label, id, tid]) => (
                <li key={id}>
                  <button data-testid={tid} onClick={() => scrollToSection(id)} className="hover:text-white transition-colors duration-300">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 mb-4">Contact</p>
            <p className="font-body text-sm text-white/80 leading-relaxed">
              F008 Industrial Growth, Ranipur,
              <br /> Pathankot — Punjab, India
            </p>
            <p className="mt-4 font-body text-sm text-white/80">
              <a href="tel:+919417021685" className="hover:text-white transition-colors duration-300">+91 94170 21685</a>
              <span className="text-white/40"> / </span>
              <a href="tel:+919417601244" className="hover:text-white transition-colors duration-300">+91 94176 01244</a>
            </p>
            <a href="mailto:dvsteels11@gmail.com" className="font-body text-sm text-white/80 hover:text-white transition-colors duration-300">
              dvsteels11@gmail.com
            </a>
            <p className="mt-4 font-body text-sm">
              <a href="https://wa.me/919417021685" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:text-white transition-colors duration-300">
                Chat on WhatsApp →
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-white/60">
          <span>© 2026 D V Steels. All rights reserved.</span>
          <span>Strong. Reliable. Built to last.</span>
        </div>
      </div>
    </footer>
  );
};
